import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isFormatted, parseDatePickerValue, parseTimeString } from './datepicker-value-parser';
import { DateRange } from '../models/date-range';

export const dateRangeValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const startDateControl = control.get('startDate');
  const endDateControl = control.get('endDate');

  const startDate = parseDatePickerValue(startDateControl.value);
  const endDate = parseDatePickerValue(endDateControl.value);
  return startDate > endDate ? { invalidDateRange: true } : null;
};

export const dateRangeComponentValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const dateRange: DateRange = control.value;
  if (dateRange == null) {
    return null;
  }
  if (dateRange.start > dateRange.end) {
    return { invalidDateRange: true };
  } else {
    return null;
  }
};

export const valuesAreDates: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const dateRange: DateRange = structuredClone(control.value);
  if (dateRange == null) {
    return null;
  }
  dateRange.start = !isFormatted(dateRange.start)
    ? parseDatePickerValue(dateRange.start)
    : dateRange.start;
  dateRange.end = !isFormatted(dateRange.end) ? parseDatePickerValue(dateRange.end) : dateRange.end;

  // if both start and end date are blank,
  // force the user to pick at least one
  // if the start date and end date are farther than 30 days, throw error
  if (!dateRange.start && !dateRange.end) {
    return { invalidDates: true };
  }
  return null;
};

export const dateRangeRequired: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const dateRange: DateRange = control.value;
  if (dateRange == null || dateRange.start == null || dateRange.end == null) {
    return {
      required: true
    };
  } else {
    return null;
  }
};

export const timeRangeValidator: (startName: string, endName: string) => ValidatorFn = (
  startName,
  endName
) => {
  return (control: AbstractControl): ValidationErrors | null => {
    const start = control.get(startName).value;
    if (start == null) return null;
    const startDate = parseTimeString(start);
    const end = control.get(endName).value;
    if (end == null) return null;
    const endDate = parseTimeString(end);
    const startMilliseconds = startDate.getTime();
    const endMilliseconds = endDate.getTime();
    if (startMilliseconds <= endMilliseconds) {
      return null;
    }
    return { timeRange: true };
  };
};
export const timeRangeNotEqualValidator: (startName: string, endName: string) => ValidatorFn = (
  startName,
  endName
) => {
  return (control: AbstractControl): ValidationErrors | null => {
    const start = control.get(startName).value;
    if (start == null) return null;
    const startDate = parseTimeString(start);
    const end = control.get(endName).value;
    if (end == null) return null;
    const endDate = parseTimeString(end);
    const startMilliseconds = startDate.getTime();
    const endMilliseconds = endDate.getTime();
    if (startMilliseconds != endMilliseconds) {
      return null;
    }
    return { timeRangeNotEqual: true };
  };
};
